export const data = [
    {
        id: 'a',
        text: 'Имя a',
        items: [
            {
                id: 'a[1/3]',
                text: 'Имя a[1/3]',
            },
            {
                id: 'a[2/3]',
                text: 'Имя a[2/3]',
                items: [
                    {
                        id: 'a[2/3][1/1]',
                        text: 'Имя a[2/3][1/1]',
                    },
                ],
            },
            {
                id: 'a[3/3]',
                text: 'Имя a[3/3]',
                items: [
                    {
                        id: 'a[3/3][1/2]',
                        text: 'Имя a[3/3][1/2]',
                        items: [
                            {
                                id: 'a[3/3][1/2][1/2]',
                                text: 'Имя a[3/3][1/2][1/2]',
                            },
                            {
                                id: 'a[3/3][1/2][2/2]',
                                text: 'Имя a[3/3][1/2][2/2]',
                            },
                        ],
                    },
                    {
                        id: 'a[3/3][2/2]',
                        text: 'Имя a[3/3][2/2]',
                    },
                ],
            },
        ],
    },
    {
        id: 'b',
        text: 'Имя b',
        items: [
            {
                id: 'b[1/2]',
                text: 'Имя b[1/2]',
            },
            {
                id: 'b[2/2]',
                text: 'Имя b[2/2]',
            },
        ],
    },
    {
        id: 'c',
        text: 'Имя c',
    },
    {
        id: 'd',
        text: 'Имя d',
    },
];

export const existingSet = [];

// prettier-ignore
export const table = {
    default: {
        // [addIds, result]
        add: [
            [[], []],
            [['c'], ['c']],
            [['c', 'd'], ['c', 'd']],
            [['b[1/2]'], ['b[1/2]']],
            [['b[1/2]', 'b[2/2]'], ['b[1/2]', 'b[2/2]', 'b']],
            [['b'], ['b', 'b[1/2]', 'b[2/2]']],
            [['b', 'b[1/2]'], ['b', 'b[1/2]', 'b[2/2]']],
            [['b[1/2]', 'b'], ['b[1/2]', 'b', 'b[2/2]']],
        ],
        // [existingIds, addIds, result]
        addToExisting: [
            [[], [], []],
            [['c'], ['c'], ['c']],
            [['c'], ['d'], ['c', 'd']],
            [['c'], ['c', 'd'], ['c', 'd']],
            [['b[1/2]'], ['b[2/2]'], ['b[1/2]', 'b[2/2]', 'b']],
            [['b[1/2]'], ['b'], ['b[1/2]', 'b', 'b[2/2]']],
        ],
        // [addIds, removeIds, result]
        remove: [
            [['d'], [], ['d']],
            [['d'], ['d'], []],
            [['b'], [], ['b', 'b[1/2]', 'b[2/2]']],
            [['b'], ['b[1/2]'], ['b[2/2]']],
            [['b'], ['b[1/2]', 'b[2/2]'], []],
            [['b'], ['b'], []],
            [['b', 'c'], ['b', 'c'], []],
            [['b', 'c'], ['b'], ['c']],
            [['c', 'd'], ['a'], ['c', 'd']],
        ],
        // [currentIds, excludeIds, result]
        exclude: [
            [['d'], [], []],
            [['d'], ['d'], []],
            [['b'], [], []],
            [['b'], ['b[1/2]'], ['b[1/2]']],
            [['b'], ['b[1/2]', 'b[2/2]'], ['b[1/2]', 'b[2/2]']],
            [['b'], ['b'], []],
            [['b', 'c'], ['b', 'c'], []],
            [['b', 'b[1/2]'], ['b[1/2]'], ['b[1/2]']],
            [['c', 'd'], ['a'], []],
        ],
    },
    singleChoice: {
        // [addIds, result]
        add: [
            [['a'], ['a']],
            [['b[1/2]'], ['b[1/2]']],
            [['b[1/2]', 'b[2/2]'], ['b[2/2]']],
            [['d'], ['d']],
            [['c', 'd'], ['d']],
            [['d', 'c'], ['c']],
        ],
        // [existingIds, addIds, result]
        addToExisting: [
            [[], [], []],
            [['c'], ['c'], ['c']],
            [['c'], ['d'], ['d']],
            [['c'], ['c', 'd'], ['d']],
            [['b[1/2]'], ['b[2/2]'], ['b[2/2]']],
            [['b[1/2]'], ['b'], ['b']],
        ],
        // [addIds, removeIds, result]
        remove: [
            [['d'], [], ['d']],
            [['d'], ['d'], []],
            [['b'], [], ['b']],
            [['b'], ['b[1/2]'], ['b']],
            [['b'], ['b[1/2]', 'b[2/2]'], ['b']],
            [['b[1/2]'], ['b'], ['b[1/2]']],
            [['b'], ['b'], []],
            [['b'], ['d'], ['b']],
            [['b', 'c'], ['c'], []],
            [['b', 'c'], ['b'], ['c']],
        ],
    },
    leavesOnly: {
        // [addIds, result]
        add: [
            [[], []],
            [['c'], ['c']],
            [['c', 'd'], ['c', 'd']],
            [['b[1/2]'], ['b[1/2]']],
            [['b[1/2]', 'b[2/2]'], ['b[1/2]', 'b[2/2]']],
            [['b'], []],
            [['b', 'b[1/2]'], ['b[1/2]']],
            [['b[1/2]', 'b'], ['b[1/2]']],
        ],
        // [existingIds, addIds, result]
        addToExisting: [
            [[], [], []],
            [['c'], ['c'], ['c']],
            [['c'], ['d'], ['c', 'd']],
            [['c'], ['c', 'd'], ['c', 'd']],
            [['b[1/2]'], ['b[2/2]'], ['b[1/2]', 'b[2/2]']],
            [['b[1/2]'], ['b'], ['b[1/2]']],
        ],
        // [addIds, removeIds, result]
        remove: [
            [['d'], [], ['d']],
            [['d'], ['d'], []],
            [['b'], [], []],
            [['b[1/2]'], ['b[1/2]'], []],
            [['b[1/2]'], ['b'], []],
            [['b[1/2]', 'b[2/2]'], ['b[1/2]'], ['b[2/2]']],
        ],
    },
    singleChoiceLeavesOnly: {
        // [addIds, result]
        add: [
            [['a'], []],
            [['d'], ['d']],
            [['b[1/2]'], ['b[1/2]']],
            [['c', 'd'], ['d']],
            [['d', 'c'], ['c']],
        ],
        // [existingIds, addIds, result]
        addToExisting: [
            [[], [], []],
            [['c'], ['c'], ['c']],
            [['c'], ['d'], ['d']],
            [['c'], ['c', 'd'], ['d']],
            [['b[1/2]'], ['b[2/2]'], ['b[2/2]']],
            [['b[1/2]'], ['b'], ['b[1/2]']],
        ],
        // [addIds, removeIds, result]
        remove: [
            [['d'], [], ['d']],
            [['d'], ['d'], []],
            [['b[1/2]'], ['b[1/2]'], []],
            [['b[1/2]'], ['b'], ['b[1/2]']],
            [['b[1/2]', 'b[2/2]'], ['b[1/2]'], ['b[2/2]']],
            [['b[2/2]', 'b[1/2]'], ['b[1/2]'], []],
        ],
    },
};
